module.exports = "iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAAXElEQVQ4y2NgGBxArf4/Mv5/XA0rRldHewPe71b5f3+dInkGJHjz/S8IFwRjEJssA/oLRMGYLAP2T5X572DEBcYgNskGgPwPcwGITVYgggKQ7EAcHOmAeAOGNAAADdZBxo/yuVsAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./~/base64-loader!./client/components/FlagControl/png/16/BB.png
// module id = 1085
// module chunks = 0